import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { MarketingCarouselQuote } from 'ContentfulDefaults/types/unifiedLanding';
import { useTextContext } from 'Contexts/textContext';

import { MarketingCarouselContainer } from './styled';

const MarketingCarousel = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 2000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 2000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const { retrieveContentfulData } = useTextContext();
  const carouselQuotes = retrieveContentfulData<MarketingCarouselQuote[]>(
    'unified_landing_page.hero.marketing_carousel_quotes',
  );

  const renderQuote = (quote?: MarketingCarouselQuote) => {
    if (!quote) {
      return null;
    }
    return (
      <>
        {quote.startText && <p>{quote.startText}</p>}
        {quote.bigText && <span className="big">{quote.bigText}</span>}
        {quote.endText && <p>{quote.endText}</p>}
        {quote.quoteAuthor && <p className="quote-name">{quote.quoteAuthor}</p>}
      </>
    );
  };
  return (
    <MarketingCarouselContainer className="carousel-outer">
      <Carousel responsive={responsive} arrows={false} autoPlay autoPlaySpeed={10000} infinite swipeable>
        <div className="quote slide1 slide">{renderQuote(carouselQuotes?.[0])}</div>
        <div className="quote slide2 slide">{renderQuote(carouselQuotes?.[1])}</div>
        <div className="stat slide3 slide">{renderQuote(carouselQuotes?.[2])}</div>
        <div className="quote slide4 slide">{renderQuote(carouselQuotes?.[3])}</div>
        <div className="stat slide5 slide">{renderQuote(carouselQuotes?.[4])}</div>
        <div className="quote slide6 slide">{renderQuote(carouselQuotes?.[5])}</div>
        <div className="stat slide7 slide">{renderQuote(carouselQuotes?.[6])}</div>
      </Carousel>
    </MarketingCarouselContainer>
  );
};

export default MarketingCarousel;
